module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '80%' : '50%'
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [(!_vm.popup.texto) ? [(_vm.popup.link) ? _c('a', {
    attrs: {
      "href": _vm.popup.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.popup.imagem,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.popup.link) ? _c('img', {
    attrs: {
      "src": _vm.popup.imagem,
      "alt": ""
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.popup.texto) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.popup.texto)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1573c6df!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/Main.vue
// module id = 525
// module chunks = 2